/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.prospecting.agent.rpc.ContactAssignmentService
 */

/**
 * Virtual record for map with known enum keys
 */

export const EmailStepEnrollmentMetaTypename = 'com.hubspot.prospecting.agent.models.cadencestepenrollment.meta.EmailStepEnrollmentMeta';

/**
 *  We shouldn't be able to do this directly. This only exists so we can test CRUD functionality
 */

export let ComHubspotProspectingAgentModelsContactassignment;
(function (_ComHubspotProspectingAgentModelsContactassignment) {})(ComHubspotProspectingAgentModelsContactassignment || (ComHubspotProspectingAgentModelsContactassignment = {}));
export let ComHubspotProspectingAgentModelsContactassignmentMeta;
(function (_ComHubspotProspectingAgentModelsContactassignmentMeta) {})(ComHubspotProspectingAgentModelsContactassignmentMeta || (ComHubspotProspectingAgentModelsContactassignmentMeta = {}));
export let ComHubspotProspectingAgentModelsErrors;
(function (_ComHubspotProspectingAgentModelsErrors) {})(ComHubspotProspectingAgentModelsErrors || (ComHubspotProspectingAgentModelsErrors = {}));
export let ComHubspotProspectingAgentModelsOutreachEnrollment;
(function (_ComHubspotProspectingAgentModelsOutreachEnrollment) {})(ComHubspotProspectingAgentModelsOutreachEnrollment || (ComHubspotProspectingAgentModelsOutreachEnrollment = {}));
export const EmailMetaTypename = 'com.hubspot.prospecting.agent.models.outreach.stepmeta.EmailMeta';
export const createContactAssignmentLiteRpc = {
  serviceName: 'com.hubspot.prospecting.agent.rpc.ContactAssignmentService',
  rpcName: 'createContactAssignmentLite',
  auth: 'app',
  fingerprint: 'S-c9rYWsi3lR_jPp1B7zk0afvCL-a8Co',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const approveCadenceSelectionRpc = {
  serviceName: 'com.hubspot.prospecting.agent.rpc.ContactAssignmentService',
  rpcName: 'approveCadenceSelection',
  auth: 'app',
  fingerprint: 'FTQRt8VdLqdR_jPp1B7zk0afvCL-a8Co',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getContactAssignmentLiteRpc = {
  serviceName: 'com.hubspot.prospecting.agent.rpc.ContactAssignmentService',
  rpcName: 'getContactAssignmentLite',
  auth: 'app',
  fingerprint: '2PZdfk0xcexR_jPp1B7zk0afvCL-a8Co',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getContactAssignmentLitesPagedRpc = {
  serviceName: 'com.hubspot.prospecting.agent.rpc.ContactAssignmentService',
  rpcName: 'getContactAssignmentLitesPaged',
  auth: 'app',
  fingerprint: 'B7y5AY_6FOT36Ai4LdSUPkafvCL-a8Co',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getContactAssignmentRpc = {
  serviceName: 'com.hubspot.prospecting.agent.rpc.ContactAssignmentService',
  rpcName: 'getContactAssignment',
  auth: 'app',
  fingerprint: '2xrzuogiCReY7JNz-YXTdEafvCL-a8Co',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getContactAssignmentV2Rpc = {
  serviceName: 'com.hubspot.prospecting.agent.rpc.ContactAssignmentService',
  rpcName: 'getContactAssignmentV2',
  auth: 'app',
  fingerprint: '2xrzuogiCRf8_nZ9reCE1EafvCL-a8Co',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getContactAssignmentsPagedRpc = {
  serviceName: 'com.hubspot.prospecting.agent.rpc.ContactAssignmentService',
  rpcName: 'getContactAssignmentsPaged',
  auth: 'app',
  fingerprint: 'FXu8dXZlMT2oX2AQuFqAHkafvCL-a8Co',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const resumeContactAssignmentsRpc = {
  serviceName: 'com.hubspot.prospecting.agent.rpc.ContactAssignmentService',
  rpcName: 'resumeContactAssignments',
  auth: 'app',
  fingerprint: 'YgNunqDXBuWF3d_d3GT0PEafvCL-a8Co',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const unenrollContactAssignmentRpc = {
  serviceName: 'com.hubspot.prospecting.agent.rpc.ContactAssignmentService',
  rpcName: 'unenrollContactAssignment',
  auth: 'app',
  fingerprint: 'YwZx0Wc3EltR_jPp1B7zk0afvCL-a8Co',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const bulkUnenrollContactAssignmentsRpc = {
  serviceName: 'com.hubspot.prospecting.agent.rpc.ContactAssignmentService',
  rpcName: 'bulkUnenrollContactAssignments',
  auth: 'app',
  fingerprint: 'RRhC79U66RDgSP2SdkCq05wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const reenqueueContactAssignmentsRpc = {
  serviceName: 'com.hubspot.prospecting.agent.rpc.ContactAssignmentService',
  rpcName: 'reenqueueContactAssignments',
  auth: 'app',
  fingerprint: 'VBXnPceQSquhGtAvVYP0gJwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getRateLimitUsageRpc = {
  serviceName: 'com.hubspot.prospecting.agent.rpc.ContactAssignmentService',
  rpcName: 'getRateLimitUsage',
  auth: 'app',
  fingerprint: 'z8GfiDQnKNDetlydOmpfekafvCL-a8Co',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const searchContactAssignmentsV2Rpc = {
  serviceName: 'com.hubspot.prospecting.agent.rpc.ContactAssignmentService',
  rpcName: 'searchContactAssignmentsV2',
  auth: 'app',
  fingerprint: 'kiurGGL58uApNJM4mT2jN0afvCL-a8Co',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getActiveAssignmentsForContactRpc = {
  serviceName: 'com.hubspot.prospecting.agent.rpc.ContactAssignmentService',
  rpcName: 'getActiveAssignmentsForContact',
  auth: 'app',
  fingerprint: 'C75n99JJww7R8RBcKRENG0afvCL-a8Co',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAssociationsRpc = {
  serviceName: 'com.hubspot.prospecting.agent.rpc.ContactAssignmentService',
  rpcName: 'getAssociations',
  auth: 'app',
  fingerprint: 'RySO-cMtJv2eIWkR6AEPakafvCL-a8Co',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAgentDecisionsForAssignmentRpc = {
  serviceName: 'com.hubspot.prospecting.agent.rpc.ContactAssignmentService',
  rpcName: 'getAgentDecisionsForAssignment',
  auth: 'app',
  fingerprint: '2PZdfk0xceyEP_PWBpIaK0afvCL-a8Co',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const kickContactAssignmentRpc = {
  serviceName: 'com.hubspot.prospecting.agent.rpc.ContactAssignmentService',
  rpcName: 'kickContactAssignment',
  auth: 'app',
  fingerprint: 'p18v4BY-IvFR_jPp1B7zk0afvCL-a8Co',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAgentDecisionsForAssignmentV2Rpc = {
  serviceName: 'com.hubspot.prospecting.agent.rpc.ContactAssignmentService',
  rpcName: 'getAgentDecisionsForAssignmentV2',
  auth: 'app',
  fingerprint: '2PZdfk0xceysvtfS04WRIkafvCL-a8Co',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const exportContactAssignmentsRpc = {
  serviceName: 'com.hubspot.prospecting.agent.rpc.ContactAssignmentService',
  rpcName: 'exportContactAssignments',
  auth: 'app',
  fingerprint: 'kiurGGL58uANF_7kXINtQkafvCL-a8Co',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getActiveOrMostRecentAssignmentForContactRpc = {
  serviceName: 'com.hubspot.prospecting.agent.rpc.ContactAssignmentService',
  rpcName: 'getActiveOrMostRecentAssignmentForContact',
  auth: 'app',
  fingerprint: 'C75n99JJww52FDccDs0p4EafvCL-a8Co',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};